// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7446e4a","509":"3153d0ab"}[chunkId] + ".chunk.js";
};